<template>
  <div :class="['DsOfferCard', orientation]" @click="$emit('click')">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'OfferCard',
  props: {
    orientation: {
      type: String,
      default: 'horizontal',
      validator(value) {
        return ['horizontal', 'vertical'].includes(value)
      },
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss">
.DsOfferCard {
  background: $color-white-high;
  border-radius: 12px;
  border: solid 1px $color-neutral-dark;
  padding: 12px 12px 12px 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  box-shadow: 0 2px 4px 0 $color-neutral-dark;
  overflow: hidden;
  background: $color-white-high;
  cursor: pointer;
  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0 4px 8px 0 $color-neutral-dark;
  }

  &.vertical {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
}
</style>
